export enum ModeEnum {
  View = 'View',
  Add = 'Add',
  Edit = 'Edit',
  Copy = 'Copy',
  Table = 'Table'
}

export function isEditMode(mode: ModeEnum): boolean {
  const found = [ModeEnum.Add, ModeEnum.Edit, ModeEnum.Copy]
    .find(f => f === mode);
  return !!found;
}
